import { AVATARS } from "@numbet/protocol";
import { t } from "../i18n.ts";
import { Avatar, Chips } from "./ui.tsx";

export const MAX_NAME = 16;

/** Nickname mit Zähler „3 / 16“ (4b, 4c). */
export function NameField({ value, onChange, autoFocus = false }: { value: string; onChange: (v: string) => void; autoFocus?: boolean }) {
  return (
    <div className="field">
      <label htmlFor="nickname">{t.nickname}</label>
      <div className="input-wrap">
        <input
          id="nickname"
          className="input"
          value={value}
          maxLength={MAX_NAME}
          autoComplete="nickname"
          placeholder={t.nicknamePlaceholder}
          autoFocus={autoFocus}
          onChange={(e) => onChange(e.target.value)}
        />
        <span className="counter" aria-hidden="true">
          {[...value].length} / {MAX_NAME}
        </span>
      </div>
    </div>
  );
}

/** Auswahl aus Initialen und sieben Symbolen (4b). */
export function AvatarPicker({ value, onChange, name }: { value: string; onChange: (v: string) => void; name: string }) {
  return (
    <div className="field">
      <div className="field-head">
        <span id="avatar-label">{t.avatarOptional}</span>
        <span>{t.avatarDefault}</span>
      </div>
      <div className="avatar-picker" role="radiogroup" aria-labelledby="avatar-label">
        {AVATARS.map((avatar) => (
          <button
            key={avatar}
            type="button"
            role="radio"
            className="avatar-option"
            aria-checked={value === avatar}
            aria-label={t.avatarNames[avatar] ?? avatar}
            onClick={() => onChange(avatar)}
          >
            <Avatar id="preview" name={name || "?"} avatar={avatar} />
          </button>
        ))}
      </div>
    </div>
  );
}

/** „Dein Platz am Tisch“ – Vorschau des eigenen Platzes (4b, 4c). */
export function SeatPreview({ name, avatar, host }: { name: string; avatar: string; host?: boolean }) {
  return (
    <section className="panel seat-preview" aria-label={t.yourSeat}>
      <span className="label" style={{ justifySelf: "start" }}>
        {t.yourSeat}
      </span>
      <Avatar id="preview" name={name || "?"} avatar={avatar} />
      <span className="name">{name.trim() || t.nicknamePlaceholder}</span>
      <Chips amount={1000} label />
      {host && <span className="pill pill-yellow">{t.host}</span>}
    </section>
  );
}

/** „Dein Raum“: 10 Fragen · 1.000 Chips · 10/20 Blinds */
export function RoomStats() {
  return (
    <section className="panel" aria-label={t.yourRoom} style={{ padding: 16 }}>
      <div className="label" style={{ marginBottom: 10 }}>
        {t.yourRoom}
      </div>
      <div className="room-stats">
        <div>
          <span className="num">10</span>
          <span>{t.statQuestions}</span>
        </div>
        <div>
          <span className="num">1.000</span>
          <span>{t.chips}</span>
        </div>
        <div>
          <span className="num">10/20</span>
          <span>{t.statBlinds}</span>
        </div>
      </div>
    </section>
  );
}
